var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-snap-container",class:{'fullscreen': _vm.fullscreen, 'horizontal': _vm.horizontal }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }